(function() { window.GUID_9aea61df_7d18_4812_a3a0_f7d78d49df31 = { getGuid: function() { return "9aea61df-7d18-4812-a3a0-f7d78d49df31"; } }; })();
var CS;
(function (CS) {
    var App;
    (function (App) {
        var Views;
        (function (Views) {
            var _Shared;
            (function (_Shared) {
                var WallSections;
                (function (WallSections) {
                    CS.Controls.Accordion.Events.Ready({
                        selector: "body",
                        childSelector: ".accordion-racingbarchart",
                        callback: (accordion, e) => {
                            if (!accordion.IsExpanded) {
                                return;
                            }
                            try {
                                const $statUserGraphsInputs = accordion.$Container.find(`.RacingBarChartSectionViewModelStatUserGraphs-${accordion.ContentId}`);
                                if (!$statUserGraphsInputs.length) {
                                    return;
                                }
                                const statUserGraphsLists = [];
                                $statUserGraphsInputs.each((index, input) => {
                                    const $input = $(input);
                                    const val = $input.val();
                                    const statUserGraphs = JSON.parse(val);
                                    if (Array.isArray(statUserGraphs)) {
                                        statUserGraphsLists.push(...statUserGraphs);
                                    }
                                });
                                if (!statUserGraphsLists.length) {
                                    throw new Error("No data found");
                                }
                                const controlId = `racing-bar-chart-root-${accordion.ContentId}`;
                                const $control = $(`#${controlId}`);
                                if (!$control.length) {
                                    throw new Error("No element found with id: " + controlId);
                                }
                                const $Persona1EntityBaseIdsHidden = accordion.$Container.find(`#RacingBarChartSectionPersona1EntityBaseIds-${accordion.ContentId}`);
                                const $Persona2EntityBaseIdsHidden = accordion.$Container.find(`#RacingBarChartSectionPersona2EntityBaseIds-${accordion.ContentId}`);
                                const Persona1EntityBaseIds = $Persona1EntityBaseIdsHidden.val();
                                const Persona2EntityBaseIds = $Persona2EntityBaseIdsHidden.val();
                                let orangeEntityBaseIds = [];
                                let blueEntityBaseIds = [];
                                try {
                                    if (!CS.Helper.isNullOrWhiteSpace(Persona1EntityBaseIds) &&
                                        !CS.Helper.isNullOrWhiteSpace(Persona2EntityBaseIds)) {
                                        orangeEntityBaseIds = Persona1EntityBaseIds.split(",").map((x) => parseInt(x));
                                        blueEntityBaseIds = Persona2EntityBaseIds.split(",").map((x) => parseInt(x));
                                    }
                                }
                                catch (error) {
                                    console.error("Error while parsing Persona1EntityBaseIds", error);
                                }
                                const racingBarChart = new CS.Controls.RacingBarChart(controlId, statUserGraphsLists, orangeEntityBaseIds, blueEntityBaseIds);
                                racingBarChart.init();
                            }
                            catch (e) {
                                console.error("Error while initializing a RacingBarChart", e);
                            }
                            const $StatsFieldPickerOverridableUrlHidden = accordion.$Container.find(`#RacingBarChartSectionStatsFieldPickerOverridableUrl-${accordion.ContentId}`);
                            const $StatGroupPickerOverridableUrlHidden = accordion.$Container.find(`#RacingBarChartSectionStatGroupPickerOverridableUrl-${accordion.ContentId}`);
                            const $EventPickerOverridableUrlHidden = accordion.$Container.find(`#RacingBarChartSectionEventPickerOverridableUrl-${accordion.ContentId}`);
                            const StatsFieldPickerOverridableUrl = $StatsFieldPickerOverridableUrlHidden.val();
                            const StatGroupPickerOverridableUrl = $StatGroupPickerOverridableUrlHidden.val();
                            const EventPickerOverridableUrl = $EventPickerOverridableUrlHidden.val();
                            accordion.$Content.offon("click.StatFieldPickerRacingBarChart", ".stats-field-picker", (e) => {
                                const $statFieldPicker = $(e.currentTarget);
                                const popupUrl = $statFieldPicker.data("popup-url");
                                if (CS.Helper.isNullOrWhiteSpace(popupUrl)) {
                                    return;
                                }
                                CS.Controls.Popup.ShowAjaxModal(popupUrl, {}, ({ popup, isPopup }) => {
                                    if (CS.Helper.isNullOrWhiteSpace(StatsFieldPickerOverridableUrl)) {
                                        return;
                                    }
                                    if (!isPopup) {
                                        return;
                                    }
                                    popup.$Control.offon("click.StatFieldPickerRacingBarChartItemClickedPopup", ".item", (e) => {
                                        const rankingStatFieldId = $(e.currentTarget).data("rankingstatfieldid");
                                        const displayStatFieldId = $(e.currentTarget).data("displaystatfieldid");
                                        if (CS.Helper.isNullOrWhiteSpace(displayStatFieldId) ||
                                            CS.Helper.isNullOrWhiteSpace(rankingStatFieldId)) {
                                            return;
                                        }
                                        const refreshUrl = StatsFieldPickerOverridableUrl.replace("___RankingStatFieldId___", rankingStatFieldId)
                                            .replace("___DisplayStatFieldId___", displayStatFieldId)
                                            .replace("___StatFieldId___", displayStatFieldId);
                                        accordion.RefreshContent(() => {
                                            popup.Close();
                                        }, refreshUrl);
                                    });
                                }, ({ popup }) => {
                                    // OnClose
                                }, true);
                            });
                            CS.Controls.EventPicker.Events.ItemClicked({
                                selector: "body",
                                childSelector: `#${accordion.ContentId} .cs-event-picker`,
                                callback: (picker, e) => {
                                    try {
                                        if (CS.Helper.isNullOrWhiteSpace(EventPickerOverridableUrl)) {
                                            throw new Error("EventPickerOverridableUrl is null or empty");
                                        }
                                        const eventId = e.data.eventId;
                                        const refreshUrl = EventPickerOverridableUrl.replace(`${CS.Helper.IntMinValue}`, eventId.toString());
                                        accordion.RefreshContent(() => {
                                            picker.Close();
                                        }, refreshUrl);
                                    }
                                    catch (error) {
                                        console.error("Error while handling event picker item click", error);
                                    }
                                },
                            });
                            CS.Controls.StatGroupPicker.Events.ItemClicked({
                                selector: "body",
                                childSelector: `#${accordion.ContentId} .cs-stat-group-picker`,
                                callback: (picker, e) => {
                                    try {
                                        if (CS.Helper.isNullOrWhiteSpace(StatGroupPickerOverridableUrl)) {
                                            throw new Error("StatGroupPickerOverridableUrl is null or empty");
                                        }
                                        const statGroupId = e.data.statGroupId;
                                        const refreshUrl = StatGroupPickerOverridableUrl.replace(`${CS.Helper.IntMinValue}`, statGroupId.toString());
                                        accordion.RefreshContent(() => {
                                            picker.Close();
                                        }, refreshUrl);
                                    }
                                    catch (error) {
                                        console.error("Error while handling stat group picker item click", error);
                                    }
                                },
                            });
                        },
                    });
                })(WallSections = _Shared.WallSections || (_Shared.WallSections = {}));
            })(_Shared = Views._Shared || (Views._Shared = {}));
        })(Views = App.Views || (App.Views = {}));
    })(App = CS.App || (CS.App = {}));
})(CS || (CS = {}));

//# sourceMappingURL=section.ready.js.map
